import styled from 'styled-components';

const WhyUsSectionWrapper = styled.section`
  padding: 100px 0;
  background: #fff;

  @media (max-width: 767px) {
    padding: 60px 0;
  }

  .why-us-content {
    display: flex;
    gap: 60px;
    align-items: flex-start;

    @media (max-width: 991px) {
      flex-direction: column;
      gap: 40px;
    }
  }

  .left-col {
    flex: 1;
    min-width: 0;
  }

  .right-col {
    flex: 1;
    min-width: 0;
  }

  h2 {
    font-size: 42px;
    font-weight: 300;
    color: #1a1a2e;
    letter-spacing: -0.025em;
    line-height: 1.2;
    margin-bottom: 30px;

    @media (max-width: 991px) {
      font-size: 36px;
    }
    @media (max-width: 575px) {
      font-size: 28px;
    }
  }

  .lead {
    font-size: 19px;
    line-height: 1.8;
    color: #333;
    font-weight: 400;
    margin-bottom: 20px;

    @media (max-width: 575px) {
      font-size: 16px;
    }
  }

  .secondary {
    font-size: 16px;
    line-height: 1.8;
    color: #666;
    font-weight: 300;
  }

  .credentials-card {
    background: #f8f9fa;
    border-radius: 16px;
    padding: 35px;
    border: 1px solid #e8e8e8;

    h3 {
      font-size: 13px;
      font-weight: 700;
      color: #f16600;
      text-transform: uppercase;
      letter-spacing: 0.12em;
      margin-bottom: 25px;
    }

    ul {
      list-style: none;
      padding: 0;
      margin: 0;
    }

    li {
      display: flex;
      align-items: center;
      gap: 14px;
      padding: 12px 0;
      border-bottom: 1px solid #eee;
      font-size: 15px;
      color: #333;
      font-weight: 400;

      &:last-child {
        border-bottom: none;
        padding-bottom: 0;
      }

      &:first-child {
        padding-top: 0;
      }

      svg {
        flex-shrink: 0;
      }
    }

    @media (max-width: 575px) {
      padding: 25px;
    }
  }

  .emphasis-card {
    margin-top: 20px;
    padding: 25px 30px;
    background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
    border-radius: 12px;
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
    position: relative;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      width: 4px;
      background: #f16600;
      border-radius: 12px 0 0 12px;
    }

    p {
      font-size: 16px;
      color: rgba(255, 255, 255, 0.9);
      line-height: 1.7;
      margin: 0;
      font-weight: 400;
      font-style: italic;
    }
  }
`;

export default WhyUsSectionWrapper;
